// @ts-strict-ignore
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef, EventEmitter,
  forwardRef, HostListener,
  Inject, Input, NgZone, OnInit, Output, QueryList, ViewChild, ViewChildren
} from '@angular/core';
import {
  SohoMessageService,
  SohoModalDialogService, SohoModuleNavSwitcherComponent,
  SohoToastService
} from 'ids-enterprise-ng';
import { LMApplicationMenuService, LMApplicationMenuSubMenuService } from '@app/components';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMLoginService } from '@login/lm-login.service';
import { LMActionFormDialogService } from '@modal/lm-action-form-dialog.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMContextService } from '@services/lm-context.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMApplicationMenuAsOfDateDialogService } from '@components/applicationmenu/asofdate/lm-application-menu-asofdate-dialog.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMApplicationMenuSearchService } from '@components/applicationmenu/search/lm-application-menu-search.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMApplicationMenuUserContextDialogService } from '@app/components';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { Router } from '@angular/router';
import { LMApplicationMenuBaseDirective } from '@components/applicationmenu/lm-application-menu-base.directive';
import { AppConstants, LMBrowserUtilService, LMUniqueIdService } from '@app/utils';
import { LMThemeService } from '@banner/lm-theme.service';
import {
  LMRoamingUIProfileService,
  RoamingUIProfileResponse,
  RoamingUIProfileResult
} from '@services/lm-roamingUIProfile.service';
import { LMCreateReportDialogService, LMReportsCatalogService, LMReportPersonalizationDialogService } from '@report/index';
import * as urltemplate from 'url-template';
import { LMApplicationMenuSubmenuComponent } from '../../submenu/lm-application-menu-submenu.component';
import { LMComponentInfoService, LMRouteComponentService } from '@app/services';
import { LMWebAppService } from '@services/lm-webapp.service';

@Component({
  selector: 'lm-application-menu-v3',
  templateUrl: 'lm-application-menu-v3.component.html',
  styleUrls: [ 'lm-application-menu-v3.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ LMRoamingUIProfileService ]
  })
export class LMApplicationMenuV3Component extends LMApplicationMenuBaseDirective implements OnInit, AfterViewInit, AfterViewChecked {
  @Input() menuSearchMode: boolean;
  @Input() searchString: string;
  @Input() menuSpecsByWebApp: LMWebAppSpec[];
  @Input() dataSearchResults: Array<LMApplicationMenuSearchResult>;
  @Input() reportSearchResults: Array<LMApplicationMenuSearchResult>;
  @Input() systemSearchResults: Array<LMApplicationMenuSearchResult>;

  @Output() menuSearchCleared: EventEmitter<any> = new EventEmitter<any>();
  @Output() sohoModuleNavExpanded: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sohoModuleNavCollapsed: EventEmitter<any> = new EventEmitter<boolean>();
  @Output() homeClicked: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(LMApplicationMenuSubmenuComponent) subMenuComponent: LMApplicationMenuSubmenuComponent;
  @ViewChild('SohoModuleNavSwitcher') sohoModuleNavSwitcher: SohoModuleNavSwitcherComponent;
  @ViewChildren('AccordionHeaders') accordionHeaders: QueryList<ElementRef>;
  @ViewChildren('ApplicationMenuSubmenus') applicationMenuSubmenus: QueryList<LMApplicationMenuSubmenuComponent>;

  // Check for home on browser back event
  @HostListener('window:popstate', ['$event']) onPopState() {
    if (window.location.pathname.includes('web/home')) {
      this.webAppName = 'web';
      this.menuItemSpecs = [];
      this.menuItemSpecs.push({
        resourceId:   this.webAppName,
        name:         'Home',
        link:         this.webAppSuiteLink,
        id:           'Home',
        label:        Soho.Locale.translate('Home'),
        resourceType: 'page'
      });

      this.updateRequired = true;
    }
  }

  constructor(
    protected sohoModalDialogService: SohoModalDialogService,
    protected sohoToastService: SohoToastService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    protected lmContextService: LMContextService,
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmSpecService: LMSpecService,
    protected lmWebAppService: LMWebAppService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmLoginService: LMLoginService,
    protected lmContextUtilService: LMContextUtilService,
    protected lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected sohoMessageService: SohoMessageService,
    protected lmApplicationMenuSearchService: LMApplicationMenuSearchService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmUserContextService: LMApplicationMenuUserContextDialogService,
    protected lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmBrowserUtilService: LMBrowserUtilService,
    @Inject(forwardRef(() => LMActionFormDialogService)) protected lmActionFormDialogService, // LMActionFormDialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected lmThemeService: LMThemeService,
    protected lmCreateReportDialogService: LMCreateReportDialogService,
    protected lmCommonReportsService: LMReportsCatalogService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected ngZone: NgZone,
    protected lmApplicationMenuSubMenuService: LMApplicationMenuSubMenuService,
    protected routeComponent: LMRouteComponentService
  ) {
    super(
      sohoModalDialogService,
      sohoToastService,
      lmAsOfDateService,
      lmContextService,
      lmApplicationMenuService,
      lmFormRequestService,
      lmFormatUtilService,
      lmSpecService,
      lmWebAppService,
      lmErrorUtilService,
      lmLoggerService,
      lmUrlUtilService,
      lmGlobalUtilService,
      lmLoginService,
      lmContextUtilService,
      lmReportPersonalizationDialogService,
      lmGlobalPersonalizationService,
      lmUniqueIdService,
      sohoMessageService,
      lmApplicationMenuSearchService,
      lmBusyIndicatorService,
      lmUserContextService,
      lmActionFormDialogService,
      changeDetectorRef,
      router,
      lmRoamingUIProfileService,
      lmThemeService,
      lmCreateReportDialogService,
      lmBrowserUtilService,
      lmCommonReportsService,
      lmComponentInfoService,
      ngZone,
      lmApplicationMenuSubMenuService,
      routeComponent
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.moduleNavDisplayMode = this.lmGlobalPersonalizationService.getGlobalPersonalization().moduleNavDisplayMode;
  }

  ngAfterViewChecked() {
    super.ngAfterViewChecked();
  }

  public updateMenuItemSpecs(appMenuSpecs: Array<LMMenuItemSpec>) {
    const menuItemSpecs = appMenuSpecs.map((menuItemSpec) => {
      menuItemSpec.validSohoIcon = this.lmThemeService.isValidSohoIcon(menuItemSpec.iconName);
      return menuItemSpec;
    });

    this.menuItemSpecs = menuItemSpecs;
  }

  public useRoleSwitcher() {
    return true;
  }

  public updateButtons() {
    this.updateMenuButtons();
  }

  public onListContextMenu(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const webAppTitle = target.dataset.val || target.innerText;
    const webApp = this.webAppSpecs.filter((webAppSpec) => webAppSpec.webAppTitle === webAppTitle)[0];
    target.setAttribute('href', webApp.webAppUrl);
  }

  public selectWebApp($event): void {
    this.showBusyIndicator();
    const url = this.webAppSpecs.filter((webAppSpec) => webAppSpec.webAppName === $event.target.value)[0].navigationMenuUrl;

    if (!url) {
      this.resetMenuItemSpecs();
      this.filteredWebAppSpecs = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName !== this.webAppName && webAppSpec.webAppTitle);
      const currentWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === $event.target.value)[0];

      this.markForRefreshAndUpdate();

      this.lmContextService.updateWebApp(currentWebAppSpec);
      this.lmGlobalUtilService.navigateByUrl(currentWebAppSpec.webAppUrl);
      this.setSelectedRole(this.lmContextService.getCurrentWebAppSpec().webAppName);

      this.hideBusyIndicator();
    } else {
      this.subscriptionArray.push(
        this.lmWebAppService.getWebAppMenuSpec($event.target.value).subscribe(
          applicationMenuSpec => {
            if (applicationMenuSpec === undefined) {
              this.handleAppMenuSpecUndefinedError();
            }

            this.saveAllLevelsResponse(applicationMenuSpec);
            this.updateMenuItemSpecs(applicationMenuSpec.menuSpecs);
            this.signOutLink = applicationMenuSpec.signOutLink;
            this.resetMenuPersonalization();
            this.lmApplicationMenuService.setApplicationMenuSpec(this.menuItemSpecs);
            this.lmApplicationMenuService.updateApplicationMenuSpec(applicationMenuSpec.menuSpecs, url);
            this.markForRefreshAndUpdate();
            this.filteredWebAppSpecs = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName !== applicationMenuSpec.webAppName && webAppSpec.webAppTitle);

            const currentWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === applicationMenuSpec.webAppName)[0];
            this.webAppTitle = currentWebAppSpec.webAppTitle;
            this.webAppIconUrl = currentWebAppSpec.webAppIconUrl;
            this.webAppName = currentWebAppSpec.webAppName;
            this.lmContextService.updateWebApp(currentWebAppSpec);
            this.lmGlobalUtilService.navigateByUrl(currentWebAppSpec.webAppUrl);
            this.setSelectedRole(this.lmContextService.getCurrentWebAppSpec().webAppName);

            // update buttons so urls on button objects are updated with new webapp paths
            this.updateButtons();
            this.hideBusyIndicator();
            this.roleSelected.emit();
          },
          error => {
            this._handleError(error);
          })
      );
    }
  }

  public openLink(link: string) {
    if (link === this.buildMenuButtonUrl(this.notificationsUrl)) {
      this.displayRedDot = false;
      // Convert timestamp from simplified ISO format (YYYY-MM-DDTHH:mm:ss.sssZ) to Landmark format (yyyyMMddHHmmssSS)
      const curTimeStamp = new Date().toISOString().slice(-24).replace(/\D/g, '').slice(0, 16);
      this.lmRoamingUIProfileService.setLastViewedNotification(curTimeStamp)
        .subscribe(
          (results: RoamingUIProfileResponse) => {
            if (results.status === RoamingUIProfileResult.COMPLETED) {
              this.lmLoggerService.log('RoamingUIProfile Updated');
            }
          });
    }

    this.lmContextService.setClearNextPageState(true);
    this.lmGlobalUtilService.navigateByUrl(link);

    if (this.lmContextService.isSmartPhone() && this.moduleNavDisplayMode === 'expanded') {
      this.sohoModuleNavCollapsed.emit();
    }
  }

  public onMenuSearchCleared() {
    this.sohoModuleNavSwitcher.roleDropdownAPI().enable();
    this.menuSearchCleared.emit();
  }

  public autoSearchMenu(searchValue: string) {
    if (searchValue === '') {
      this.onMenuSearchCleared();
    } else {
      this.searchFieldText$.next(searchValue);
    }
  }

  private getIdForMenuItem(menuItem: LMMenuItemSpec): string {
    const testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;
    let id;

    if (!this.subMenuComponent) {
      return id;
    }

    if (testVersion1) {
      id = this.subMenuComponent.menuIdV1(menuItem);
    } else {
      id = this.subMenuComponent.menuIdV2(menuItem);
    }

    return id;
  }

  public onModuleNavClick($event: MouseEvent, menuItem: LMMenuItemSpec) {
    if (($event.ctrlKey || $event.metaKey) && $event.shiftKey) {
      $event.stopImmediatePropagation();
      this.displayComponentInfo(menuItem as LMComponentInfo, $event);
      return false;
    }

    const firstChild = menuItem?.menu ? menuItem?.menu[0] : undefined;
    const firstChildIsSubMenu = firstChild?.menu;
    const firstChildId = firstChild ? this.getIdForMenuItem(firstChild) : this.getIdForMenuItem(menuItem);
    const actionSpecHasParameters = firstChild && firstChild.actionSpecHasParameters;
    const actionTaskOrActionItem = firstChild && (firstChild.isClassActionItem || firstChild.isTaskActionItem);

    // Menu item has no children
    if (!menuItem.menu && (!menuItem.isClassActionItem && !menuItem.isTaskActionItem)) {
      this.onMenuItemClicked($event, menuItem);
      // this.openLink(menuItem.link);
      return;
    }

    // Expand and open menu when clicking on icon
    // Navigate to first item if it is not a submenu
    // Don't navigate if menu is already expanded
    if (firstChild
      && !firstChildIsSubMenu
      && !actionSpecHasParameters
      || (!menuItem.menu && (menuItem.isClassActionItem || menuItem.isTaskActionItem))
    ) {
      const _menuItem = (!menuItem.menu && menuItem.isClassActionItem || menuItem.isTaskActionItem) ? menuItem : firstChild;
      this.onMenuItemClicked($event, _menuItem);

      // Remove all selections
      if (this.moduleNavDisplayMode === 'expanded' && menuItem.expanded) {
        this.unSelectAll();
      }

      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          // Remove selection from parent
          document.getElementById(menuItem.id).closest('.accordion-header').classList.remove('is-focused');
          document.getElementById(menuItem.id).closest('.accordion-header').classList.remove('is-selected');

          // Add selection to first child
          document.getElementById(firstChildId).closest('.accordion-header').classList.add('is-selected');
          document.getElementById(firstChildId).closest('.accordion-header').classList.add('is-focused');
        }, 10);
      });
    }

    // If first item is a sub menu
    // Expand application menu if in collapsed state
    if (firstChildIsSubMenu  && this.moduleNavDisplayMode === 'collapsed') {
      this.expandSohoModuleNav();
      this.unSelectAll();

      // Add selection to parent item
      setTimeout(() => {
        document.getElementById(menuItem.id).closest('.accordion-header').classList.add('is-selected');
      });
    }

    // If first item is an action with params
    if (!firstChildIsSubMenu && actionTaskOrActionItem && actionSpecHasParameters && this.moduleNavDisplayMode === 'collapsed') {
      this.expandSohoModuleNav();
      this.unSelectAll();

      // Add selection to parent item
      setTimeout(() => {
        document.getElementById(menuItem.id).closest('.accordion-header').classList.add('is-selected');
      });
    }


    // Track expand for page state
    menuItem.expanded = !menuItem.expanded;
    this.lmApplicationMenuService.saveExpandedMenus(menuItem);

    // Emit menu loaded event back to app.component when menu expanded
    if (menuItem.expanded) {
      this.menuLoaded.emit($event);
    }
  }

  public expandSohoModuleNav() {
    this.sohoModuleNavExpanded.emit();
  }

  private showReportCatalog() {
    return this.reportsUrl && this.reportsUrl.includes('/report/catalog');
  }

  private buildMenuButtonUrl(link: string): string {
    if (link) {
      const compiledTemplate = urltemplate.parse(link);
      link = compiledTemplate.expand({
        urlPdlOrDa: this.lmContextService.getUrlPdlOrDa(),
        webApp:     this.lmContextService.getCurrentWebAppSpec().webAppName
      });

      return link;
    }

    return '';
  }

  public updateMenuButtons() {
    const notificationsButton = {
      icon: 'notification',
      label: Soho.Locale.translate('Notifications'),
      id: 'Notifications_button',
      automationId: 'lm-appmenu-notifications-button',
      url: this.buildMenuButtonUrl(this.notificationsUrl)
    };

    const createReportButton = {
      icon: '',
      label: Soho.Locale.translate('CreateReport'),
      id: 'CreateReport_link',
      automationId: 'lm-appmenu-create-report-button',
      url: ''
    };

    this.applicationMenuButtons = [];
    this.menuItemSearch = [];

    // Add print files to menu
    if (this.evaluateApplicationMenuOption('HideMenuPrintFiles')) {
      if(!this.showReportCatalog()) {
        this.applicationMenuButtons.push({
          icon: 'print',
          label: Soho.Locale.translate('PrintFiles'),
          id: 'PrintFiles_button',
          automationId: 'lm-appmenu-print-files-button',
          url: this.buildMenuButtonUrl(this.printFilesUrl)
        });
      }
    }

    // Notifications button
    if (this.evaluateApplicationMenuOption('HideMenuNotifications')) {
      this.notificationsButton = notificationsButton;
      this.menuItemSearch.push(this.notificationsButton);
    }

    // Create report button
    if (this.showDataAndReportingOptions('CreateReport')) {
      this.createReportButton = createReportButton;
    }

    if (this.inbasketEnabled && this.evaluateApplicationMenuOption('HideMenuInbasket')) {
      this.inbasketButton = {
        icon: 'mail',
        label: Soho.Locale.translate('Inbasket'),
        id: 'Inbasket_button',
        automationId: 'lm-appmenu-in-basket-button',
        url: this.buildMenuButtonUrl(this.inBasketUrl)
      };
      this.menuItemSearch.push(this.inbasketButton);
    }

    if (this.evaluateApplicationMenuOption('HideMenuJobs')) {
      this.applicationMenuButtons.push({
        icon: 'cascade-objects',
        label: Soho.Locale.translate('Jobs'),
        id: 'Jobs_button',
        automationId: 'lm-appmenu-jobs-button',
        url: this.buildMenuButtonUrl(this.jobsUrl)
      });
    }

    if (this.evaluateApplicationMenuOption('HideMenuReports')) {
      if (this.reportsUrl) {
        let reportsLabel = Soho.Locale.translate('Reports');
        if (this.reportsUrl.includes('/report/catalog')) {
          reportsLabel = Soho.Locale.translate('ReportCatalog');
        }
        this.reportsButton = {
          icon: 'report',
          label: reportsLabel,
          id: 'Reports_button',
          automationId: 'lm-appmenu-reports-button',
          url: this.buildMenuButtonUrl(this.reportsUrl)
        };
        this.menuItemSearch.push(this.reportsButton);
      }
    }

    if (this.evaluateApplicationMenuOption('HideMenuActions')) {
      this.applicationMenuButtons.push({
        icon: 'checkbox',
        label: Soho.Locale.translate('Actions'),
        id: 'Actions_button',
        automationId: 'lm-appmenu-actions-button',
        url: this.buildMenuButtonUrl(this.actionsUrl)
      });
    }

    if (this.personalizationEnabled) {
      this.applicationMenuButtons.push({
        icon: 'quick-edit',
        label: Soho.Locale.translate('Personalizations'),
        id: 'Personalization_button',
        automationId: 'lm-appmenu-personalization-button',
        url: this.buildMenuButtonUrl(this.personalizationsUrl)
      });
    }

    if (this.enableSavedSearch) {
      this.applicationMenuButtons.push({
        icon: 'print-preview',
        label: Soho.Locale.translate('SavedSearches'),
        id: 'SavedSearches_button',
        automationId: 'lm-appmenu-savedSearches-button',
        url: this.buildMenuButtonUrl(this.savedSearchesUrl)
      });
    }

    this.menuItemSearch = this.menuItemSearch.concat(this.applicationMenuButtons);

    // Add About Link
    if (!this.hasChangePasswordLink) {
      this.aboutButton = {
        icon: 'print-preview',
        label: Soho.Locale.translate('About'),
        id: 'About_button',
        url: this.buildMenuButtonUrl(this.aboutLink),
        automationId: 'lm-about-button'
      };
      this.menuItemSearch.push(this.aboutButton);
    }

    if (this.appHelpLink && !this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Help'),
        id: 'Help_button',
        url: this.appHelpLink,
        automationId: 'lm-help-button'
      });
    }

    if (this.proxyEnabled || this.proxyMode || this.proxyManagementLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Proxy'),
        id: 'Proxy_button',
        url: '',
        automationId: 'lm-proxy-button'
      });
    }

    if (this.enableUserContextMenu) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('ActorContextMenuLabel'),
        id: 'ContextMenu_button',
        url: '',
        automationId: 'lm-contextMenu-button'
      });
    }

    if (this.createReportUrl) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('CreateReport'),
        id: 'CreateReport_button',
        url: '',
        automationId: 'lm-createReport-button'
      });
    }

    if (!this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Settings'),
        id: 'Settings_button',
        url: '',
        automationId: 'lm-settings-button'
      });
    }

    if (this.allowSetAsOfDate) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('AsOfDateLabel'),
        id: 'AsOfDate_button',
        url: '',
        automationId: 'lm-asOfDate-button'
      });
    }
  }

  public searchMenu(dataMenus: LMApplicationMenuDataMenu[], reports: LMApplicationMenuReportMenu[]): void {
    this.menuSearchResultsByWebApp = this.lmApplicationMenuSearchService.matchMultiMenus(this.lmWebAppService.getAllCachedWebApps(), this.model.searchFieldValue);
    this.dataSearchResult = this.lmApplicationMenuSearchService.matchData(dataMenus);
    this.reportSearchResult = this.lmApplicationMenuSearchService.matchReports(reports);
    this.systemSearchResults = this.lmApplicationMenuSearchService.matchMenuOptions(this.menuItemSearch, this.model.searchFieldValue);

    this.searchMode = true;

    const event: LMApplicationMenuSearchEvent = {
      searchString:              this.model.searchFieldValue,
      menuSearchResultsByWebApp: this.menuSearchResultsByWebApp,
      dataSearchResults:         this.dataSearchResult,
      reportSearchResults:       this.reportSearchResult,
      systemSearchResults:       this.systemSearchResults,
      toggleMenu:                Object.keys(this.menuSearchResultsByWebApp).length > 0 ? 'Applications' : this.reportSearchResult.length > 0 ? 'Reports' : 'Data'
    };

    // Disable web app switcher dropdown when search is open
    this.sohoModuleNavSwitcher.roleDropdownAPI().readonly();
    this.sohoModuleNavSwitcher.roleDropdownAPI().disable();

    this.menuSearched.emit(event);
    this.hideBusyIndicator();
  }

  public onHome(): void {
    const currentWebAppSpec = this.webAppSpecs.filter(webAppSpec => webAppSpec.webAppName === this.webAppName);
    const link = this.webAppName === 'web' ? this.webAppSuiteLink : currentWebAppSpec[ 0 ].webAppUrl;
    this.openLink(link);
    this.unSelectAll();

    this.homeClicked.emit();
  }

  public onMenuSearched(event: LMApplicationMenuSearchEvent) {
    this.menuSearched.emit(event);
    this.setSelectedRole(this.lmContextService.getCurrentWebAppSpec().navigationMenuUrl);
  }

  public onWebAppMenuLoaded() {
    this.sohoModuleNavSwitcher.updated({ roleDropdownLabel: this.webAppTitle, moduleButtonText: this.webAppTitle });
    // Set roles
    const roles = [];
    this.webAppSpecs.forEach((webAppSpec: LMWebAppSpec) => {
      if (webAppSpec.webAppTitle) {
        roles.push({ text: webAppSpec.webAppTitle, value: webAppSpec.webAppName, icon: webAppSpec.webAppIconUrl });
      }
    });

    if (this.webAppName === 'web') {
      roles.push({ text: 'Web', value: 'web', icon: `${this.lmContextService.getContext().baseStaticContentUrl}/lib/landmark/images/web.svg` });
    }

    this.sohoModuleNavSwitcher.setRoles(roles);
    this.setSelectedRole(this.webAppName);
    this.webAppMenuLoaded.emit({ roleSwitcher: this.roleSwitcher });
  }

  private unSelectAll(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.accordionHeaders.forEach((elementRef) => elementRef.nativeElement.classList.remove('is-selected'));
      });
    });
  }

  // Value to be displayed in the role switcher dropdown
  private setSelectedRole(webAppName: string) {
    this.sohoModuleNavSwitcher.roleDropdownAPI().selectValue(webAppName);
  }

  /**
   * Set href url when a right click is executed
   * @param event
   * @param menuItem
   */
  public onMenuItemRightClicked(event: MouseEvent, menuItem: LMMenuItemSpec) {
    if (menuItem && menuItem.link) {
      const currentTarget = event.currentTarget as HTMLElement;
      const children = currentTarget.children as HTMLCollection;
      if (currentTarget.nodeName === 'A') {
        (event.currentTarget as HTMLElement).setAttribute('href', menuItem.link);
      } else if (children) {
        Array.from(children).forEach((element) => {
          if (element.nodeName === 'A') {
            (element).setAttribute('href', menuItem.link);
          }
        });
      }
    }
  }

  public headerAutomationId(menuItem: LMMenuItemSpec): string {
    return `lm-${menuItem.automationId}-accordion-header`;
  }
}
